import React from 'react';
import Hero from '../components/Hero';

const HeroPage = () => {
  return (
    <>
      <Hero />
    </>
  );
};

export default HeroPage;
